import { OrganizationsContext } from "contexts";
import { useContext } from "react";

const useSelectedOrganization = () => {
  const {
    state: { selectedOrganization },
  } = useContext(OrganizationsContext);

  return selectedOrganization;
};

export default useSelectedOrganization;
